import { render } from "./StartViewSpinner.vue?vue&type=template&id=232ea118&scoped=true"
import script from "./StartViewSpinner.vue?vue&type=script&lang=js"
export * from "./StartViewSpinner.vue?vue&type=script&lang=js"

import "./StartViewSpinner.vue?vue&type=style&index=0&id=232ea118&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232ea118"]])

export default __exports__